import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
//import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddmodifiertypeComponent } from './addmodifiertype/addmodifiertype.component';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-modifiertype',
  templateUrl: './modifiertype.component.html',
  styleUrls: ['./modifiertype.component.css']
})
export class ModifiertypeComponent implements OnInit, AfterViewInit, OnDestroy {

  modifiertypeColl: any = [];
 
   isadd: boolean = false;
   isedit: boolean = false;
   isdelete: boolean = false;
   isview: boolean = false;
   isprint: boolean = false;
   isexport: boolean = false;
 
   isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;
   formname: String = "Modifiertype";
 
 
   searchtxt: any = "";
   columnDefs = [
     { headerName: 'Modifier Type', field: 'modifiertypename' },
     { headerName: 'Status', field: 'activestatus' ,type:'activestatus'},
     { headerName: 'Created On', field: 'createdon',type:'datetime' },
   ]
 
   gridOptions = {
     enableactioncol: true,
     columnDefs: this.columnDefs,
   };
 
   constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal,
     private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) { this.fnServiceChanges(); }
 
   //User Check
    //User Check
    fnServiceChanges(){
     this.loginService.serviceloginChange.subscribe((value) => {
       if (this.loginService.fnCheckCompany()) {
           if(this.loginService.fnCheckUser()){                
               this.fnCheckPrivilage();
               if(this.isview){
                 this.isloading=true;
                 this.fnOnInitForm();
               }
               else{
                 this.fnUserFailedForm();
               }    
           }
           else{
             this.fnUserFailedForm();
           }
         }
         else {
           this.loginService.fnCompanyFaildRedirect();
         }
     });
   }
 
 
   ngOnInit() {
     try{
       if (this.loginService.fnCheckCompany()) {
       if(this.loginService.fnCheckUser()){         
         this.fnCheckPrivilage();
         if(this.isview){
           this.isloading=true;
           this.fnOnInitForm();
         }
         else{
           this.fnUserFailedForm();
         }          
       }
       else{
         this.loginService.fnGetUserRoleList();
       }
     }
     else {
       this.loginService.fnCompanyFaildRedirect();
     }
     }catch(ex){
       this.fnShowErrorMsg(ex);
     }
   }
   fnOnInitForm() {
     this.fngetModifiertype();
   }
 
   fnCheckPrivilage() {
 
     this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
     this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
     this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
     this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
     this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
     this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
   }
 
   fnUserFailedForm() {
     this.isprivilage = true;
   }
 
 
 
   ngAfterViewInit(): void {
 
   }
 
   ngOnDestroy(): void {
 
   }
 
   fngetModifiertype() {
 
     if (this.showProgress) {
       return;
     }
 
     this.fnShowProgress();
     var data = {
       'modifiertypeid': 0,
       'companyid': this.loginService.fnGetCompanyId(),
       'organizationid': this.loginService.fnGetOrganizationId(),
      
     }
     this.appService.getModifiertype(data)
       .subscribe(
         (res) => {
 
           this.fnHideProgress();
           if (res.json().status == 200) {
             this.modifiertypeColl = res.json().result;
             this.fnSetDataTable();
           }
           else if (res.json().status == 400) {
             this.toastr.error('Error', res.json().err_field);
           }
 
 
         },
         (err) => {
           this.fnHideProgress();
           this.toastr.error('Error', err);
         })
   }
 
   fnAddModifiertype() {
     try {
       const modalRef = this.productFindService.open(AddmodifiertypeComponent, { size: <any>'m', backdrop: 'static' });
 
 
       modalRef.componentInstance.ngOnInit();
 
       modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
 
         this.fngetModifiertype();
 
       });
 
 
     } catch (ex) {
       this.fnShowErrorMsg(ex);
     }
   }
 
   fnEditModifiertype(pBO) {
   
     try {
     
       var deptid = pBO.modifiertypeid
       if (!this.isedit) {
         return;
       }
       const modalRef = this.productFindService.open(AddmodifiertypeComponent, { size: <any>'m', backdrop: 'static' });
       modalRef.componentInstance.modifiertypeid = deptid;
 
       modalRef.componentInstance.ngOnInit();
       modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
 
         this.fngetModifiertype();
 
       });
 
     } catch (ex) {
       this.fnShowErrorMsg(ex);
     }
   }
   public fnDeleteConfirm(pBO) {
     try {
       var deptid = pBO.modifiertypeid
       this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete Modifiertype?')
         .then((confirmed) => {
           if (confirmed) {
             this.fnDeleteModifiertype(deptid)
           }
         }
         );
       //.catch(() => );
     } catch (ex) {
       this.fnShowErrorMsg(ex);
     }
   }
 
   private fnDeleteModifiertype(deptid) {
     var data = {
       'modifiertypeid': deptid,
     }
     this.appService.fnDeleteModifiertype(data)
       .subscribe(
         (res) => {
           if (res.json().status === 200) {
             this.toastr.success('', " The Modifiertype has been deleted successfully.");
 
             this.fnInsertActivityLog('DELETE', deptid, this.fnGetDescription(deptid));
 
             this.fngetModifiertype();
           } else {
             this.toastr.error('', res.json().err_field);
           }
         },
         (err) => {
           this.toastr.error('Error', err);
         })
   }
 
 
 
 
 
 
 
   private fnSetDataTable() {
 
   }
 
 
   fnPrintData() {
     try {
 
 
     } catch (ex) {
       this.fnShowErrorMsg(ex);
     }
   }
 
   fnExportData() {
     try {
 
 
     } catch (ex) {
       this.fnShowErrorMsg(ex);
     }
   }
  
   fnActionExportClick()  {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.modifiertypeColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  }
 
   fnGetDescription(id) {
     const index = this.modifiertypeColl.findIndex(sku => sku.modifiertypeid === id);
 
     if (index) {
       return this.modifiertypeColl[index].productgroup;
     }
     else {
       return "";
     }
 
   }
 
   public fnSearchDatatable(value) {
 
 
   }
 
   fnInsertActivityLog(action, refno, desc) {
     try {
       var data = {
         logtype: action,
         logat: this.formname,
         refnum: refno,
         logdescr: desc,
         logby: this.loginService.fnGetModUserId(),
         'companyid': this.loginService.fnGetCompanyId(),
       }
 
 
       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{
 
         });
 
     } catch {
 
     }
   }
 
 
 
   private fnShowProgress() {
     this.showProgress = true;
   }
   private fnHideProgress() {
     this.showProgress = false;
   }
 
 
   private fnShowErrorMsg(ex) {
     this.toastr.warning('Internal Error', ex);
   }
 
 
 
 
 }
 